function DisclosureStep() {
    var self = this;
    BaseStepModel.apply(self, ['disclosure_panel']);

    self.isLoadingDisclosure = ko.observable(true);
    self.htmlBeforeRegistrationDisclosure = ko.observable(null);
    self.htmlDisclosure = ko.observable(null);

    self.loadDisclosure = function (isBusiness) {
        $.ajax({
            type: 'GET',
            url: '/Mobile/Registration/Disclosure?isBusiness=' + isBusiness,
            success: function (data) {
                self.htmlBeforeRegistrationDisclosure(data.HtmlBeforeRegistrationDisclosure);
                self.htmlDisclosure(data.Disclosure);

                window.setTimeout(function() {
                    self.isLoadingDisclosure(false);
                    registrationArea.showDisclosureAgreeButton();
                }, 2000);
            },
            error: function (request, status, error) {
                mobileUtils.flashMessage('Error', Alkami.Localization.SiteText['Disclosure.LoadingError']);
                self.isLoadingDisclosure(false);
            }
        });
    }

    self.show = function () {
        self.resetState();
        registrationArea.showDisclosurePanel();
    }
}